export default __webpack_public_path__ + "8bbcbb02ecf6531ac6b1c25ef45b76e0.png";